import { render, staticRenderFns } from "./EtransactAirtimeWallet.vue?vue&type=template&id=be3d595a&scoped=true"
import script from "./EtransactAirtimeWallet.vue?vue&type=script&lang=js"
export * from "./EtransactAirtimeWallet.vue?vue&type=script&lang=js"
import style0 from "./EtransactAirtimeWallet.vue?vue&type=style&index=0&id=be3d595a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3d595a",
  null
  
)

export default component.exports